
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/understanding-distributed-systems",
      function () {
        return require("private-next-pages/books/understanding-distributed-systems.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/understanding-distributed-systems"])
      });
    }
  